module.exports = __webpack_public_path__ + "static/media/4전쟁-제무시.f20a0fe3.mp3";